import { useMemo } from "react";
import { useMsal } from "@azure/msal-react";
import { isAdmin } from "../auth/admin";

/**
 * Returns true when the signed-in account has the Admin app role (see
 * src/auth/admin.ts). Re-evaluates whenever the active account changes.
 */
export function useIsAdmin(): boolean {
  const { instance, accounts } = useMsal();
  const account = instance.getActiveAccount() ?? accounts[0];
  return useMemo(
    () => isAdmin(account?.idTokenClaims as Record<string, unknown> | undefined),
    [account]
  );
}
